import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

let csrfToken = null;

export const setCsrfToken = (token) => {
  csrfToken = token;
};

export const getCsrfToken = () => csrfToken;

export const clearCsrfToken = () => {
  csrfToken = null;
};

export const refreshCsrfToken = async () => {
  try {
    const response = await axios.get(`${API_URL}/csrf-token`, { withCredentials: true });
    setCsrfToken(response.data.csrfToken);
    return response.data.csrfToken;
  } catch (error) {
    console.error('Failed to refresh CSRF token:', error);
    throw error;
  }
};